import { numericSorter } from '@lib/generic.utils'
import { agPriceCol } from '@/ag-grid/ag-columns'
// Components
import StakeholdersColumn from './StakeholdersColumn'

export default {
  computed: {
    gridOptions() {
      return {
        columnDefs: [
          {
            headerName: this.departmentLabel.plural,
            field: 'department',
            flex: 1,
            cellRenderer: params => params.value?.name || 'N/A',
            editable: params => !!params.data.department,
            cellClassRules: {
              'editable-cell': params => !!params.data.department
            },
            cellEditorFramework: 'DropdownEditor',
            cellEditorParams: params => ({
              options: params.context.costAllocationCmp.departments,
              optionLabel: 'name',
              optionValue: 'id',
              getValue: model => {
                const department = params.data.department
                return { ...department, id: model.id, name: model.name }
              }
            })
          },

          {
            headerName: this.costCenterLabel.singular,
            field: 'cost_center',
            cellRenderer: params => params.value?.name || 'N/A',
            editable: params => !!params.data.department,
            cellClassRules: {
              'editable-cell': params => !!params.data.department
            },
            cellEditorFramework: 'DropdownEditor',
            cellEditorParams: params => ({
              options: params.context.costAllocationCmp.costCenters,
              optionLabel: 'name',
              optionValue: 'id',
              getValue: model => {
                const cost_center = params.data.cost_center
                return { ...cost_center, id: model.id, name: model.name }
              }
            })
          },

          {
            headerName: 'Share',
            field: 'percentage',
            valueGetter: params => {
              const share = params.data.percentage

              if (share) return parseFloat(share)
              return null
            },
            comparator: (a, b, nodeA, nodeB) => {
              return numericSorter(nodeA.data.percentage ?? 0, nodeB.data.percentage ?? 0)
            },
            cellRenderer: params => {
              const value = params.value

              if (value === null) return 'N/A'
              return `${Math.round(value * 100) / 100} %`
            },
            type: 'rightAligned',
            minWidth: 130,
            editable: params => !!params.data.department,
            cellClassRules: {
              'editable-cell': params => !!params.data.department,
              'ag-right-aligned-cell': params => true
            },
            cellEditorFramework: 'PriceEditor',
            cellEditorParams: {
              decimals: 8
            }
          },

          agPriceCol('Price', 'price', {
            editable: params => !!params.data.department,
            cellClassRules: {
              'editable-cell': params => !!params.data.department
            }
          }),

          {
            headerName: 'Stakeholders',
            flex: 2,
            cellRendererFramework: StakeholdersColumn
          },

          {
            headerName: 'Actions',
            type: 'centerAligned',
            cellRendererFramework: 'ActionsCol',
            cellRendererParams: params => ({
              popupActions: [
                { name: 'delete', label: `Delete ${this.departmentLabel.singular}`, textColorClass: 'text-danger-1' }
              ],
              onPopupAction: () => this.deleteDepartment(params.data)
            })
          }
        ],

        defaultColDef: {
          suppressSizeToFit: true
        },

        domLayout: 'autoHeight'
      }
    }
  }
}
